import React, { useEffect, useMemo, useState } from 'react';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi2';
import { NavLink, useLocation } from 'react-router-dom';

const SidebarMenu = ({ title, icon: Icon, items = [], collapsed, onNavigate }) => {
  const location = useLocation();
  const hasActiveChild = useMemo(
    () => items.some((item) => location.pathname === item.href || location.pathname.startsWith(`${item.href}/`)),
    [items, location.pathname],
  );
  const [isOpen, setIsOpen] = useState(hasActiveChild);

  useEffect(() => {
    if (hasActiveChild && !collapsed) {
      setIsOpen(true);
    }
  }, [collapsed, hasActiveChild]);

  const toggleMenu = () => {
    if (!collapsed) {
      setIsOpen((currentValue) => !currentValue);
    }
  };

  return (
    <div className={`sidebar-menu ${hasActiveChild ? 'active' : ''}`}>
      <button
        className={`sidebar-link sidebar-menu-button ${isOpen ? 'open' : ''}`}
        type="button"
        aria-expanded={isOpen}
        title={title}
        onClick={toggleMenu}
      >
        <Icon aria-hidden="true" />
        <span className="hide-menu">{title}</span>
        <span className="submenu-caret">
          {isOpen ? <HiOutlineChevronUp aria-hidden="true" /> : <HiOutlineChevronDown aria-hidden="true" />}
        </span>
      </button>

      <div className={`sidebar-submenu ${isOpen && !collapsed ? 'show' : ''}`}>
        {items.map((item) => {
          const ItemIcon = item.icon;

          return (
            <NavLink
              key={item.href}
              className={({ isActive }) => `sidebar-sublink ${isActive ? 'active' : ''}`}
              to={item.href}
              onClick={onNavigate}
            >
              <ItemIcon aria-hidden="true" />
              <span>{item.title}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarMenu;
